import { __decorate, __metadata } from "tslib";
import { CountryISOCodeEnum } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { ArrayUnique, IsArray, IsEnum, IsOptional } from 'class-validator';
import { DefaultStoreExposeGroup } from '../interface';
export class DefaultStoreCountryDto {
}
__decorate([
    ApiProperty({ enum: CountryISOCodeEnum }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsEnum(CountryISOCodeEnum, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], DefaultStoreCountryDto.prototype, "defaultCode", void 0);
__decorate([
    ApiProperty({ enum: CountryISOCodeEnum, isArray: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsEnum(CountryISOCodeEnum, { groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH], each: true }),
    IsArray({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    ArrayUnique({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Array)
], DefaultStoreCountryDto.prototype, "codeFilters", void 0);
//# sourceMappingURL=DefaultStoreCountryDto.js.map